import React, { useContext, useEffect, useRef, useState } from "react";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import ApexCharts from "react-apexcharts";
import { NavLink } from "react-router-dom";
import { currentDateAndTime, monthData } from "../../Constants/constants";
import GaugeChart from "react-gauge-chart";

import Select from "react-select"; 
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import { NoRecords } from "../../Components/Shimmer";
import { useNavigate } from 'react-router-dom';

  

const EmployeesDashboard = () => {
  const { apiURL, apiHeaderJSON } = useContext(ConfigContext);
  const sourceDivRef = useRef(null); // Ref for the source div
  const [targetDivHeight, setTargetDivHeight] = useState("auto");
  const [monthYear, setMonthYear] = useState("");
  const inputRef = useRef(null);
  const [dailyData, setDailyData] = useState({
    employee_count: "",
    inactive_count: "",
    presentee_count: "",
    today_leave_count: 0,
    monthly_leave_count: "",
  });
  const [selectedMonthYear, setSelectedMonthYear] = useState(null);
  const [selectedOfferStatus, setSelectedOfferStatus] = useState("0");

  const [errors, setErrors] = useState({});
  const [monthlyAttendanceData, setMonthlyAttendanceData] = useState({
    present_rate: "0.00%",
    absence_rate: "0.00%",
  });

  const [departmentAttendanceData, setDepartmentAttendanceData] = useState([]);
const[gross,setGross] =useState([]);
  // const [attendanceData, setAttendanceData] = useState({
  //   absence_rate: "0.00%",
  //   present_rate: "0.00%",
  // });
  // const [AbsenceData,  setAbsenceData] = useState({});

  // const [PresentData, setPresentData] = useState({ });
  // const absenceRate = parseFloat(.absence_rate) / 100; // Convert "16.99%" to 0.1699
  //  const presentRate = parseFloat(attendanceData.present_rate)

  const [offerLetterStatusCounts, setOfferLetterStatusCounts] = useState({});
  const [offerSentCount, setOfferSentCount] = useState({});
  const currentDateAndTime = () => {
    return new Date().toISOString()?.slice(0, 19).replace("T", " "); // Example: '2024-12-24 15:30:00'
  };

  const currentDate = new Date();
  const currentMonth = String(currentDate.getMonth() + 1).padStart(2, "0"); // "11"
  const currentYear = currentDate.getFullYear(); // "2024"
  const [genderData, setGenderData] = useState([]);
  const [chartOptionsLeave, setChartOptionsLeave] = useState([]);
  const [attendanceData, setAttendanceData] = useState({
    present_rate: "0",
    absence_rate: "0",
  });
  const[ chartOptionsGross, setChartOptionsGross] = useState([]);

  const [leaveData, setLeaveData] = useState([]);

  const [offerLetterCount, setOfferLetterCount] = useState(0);
  const [appointmentLetterCount, setappointmentLetterCount] = useState(0);
  const [selectMonthAppointment, setselectMonthAppointment] = useState("");
  const [monthYearOptions, setMonthYearOptions] = useState([]);
  const [selectMonthJoin, setSelectMonthJoin] = useState([]);

  const [departmentData, setDepartmentData] = useState([]);
  const [chartOptions, setChartOptions] = useState({});
  const [chartOptionsfGender, setChartOptionsGender] = useState({});
  const [charAttendenceData, setCharAttendenceData] = useState({});
  const [joiningData, setJoiningData] = useState({});
  const [locationCount, setLocationCount] = useState({});
  const [chartLocationOptions, setChartLocationOptions] = useState({});
  const[chartEarnedOptions,setChartEarnedOptions] = useState();
  const[departmentEarnedData,setDepartmentEarnedData]=useState();
  const[locationEarnedData,setLocationEarnedData]=useState();
  const[designationData,setDesignationData]=useState();
  const[chartEarnedLocOptions,setChartEarnedLocOptions]=useState();
  const[designationOptions,setDesignationOptions]=useState();
  const[departmentNetData,setDepartmentNetData]=useState();
  const[chartNetOptions,setChartNetOptions]=useState();
  const[locationNetData,setLocationNetData]=useState();
  const[chartNetLocOptions,setChartNetLocOptions]=useState();
  const[chartOverTimeOptions,setChartOverTimeOptions]=useState();
  const[departmentOverTimeData,setDepartmentOverTimeData]=useState();
  const[selectMonthOver,setSelectMonthOver]=useState();
  const[selectMonthDesignationOver,setSelectMonthDesignationOver]=useState();
  const[selectMonthLocOver,setSelectMonthLocOver]=useState();
  const[chartLocOverTimeOptions,setChartLocOverTimeOptions]=useState();


  
  // Helper function to get current month and year in "MM-YYYY" format
  const getCurrentMonthYear = () => {
    const date = new Date();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${year}`;
  };
  const [visibleDepartments, setVisibleDepartments] = useState(6); // Start with 6 departments

  const navigate = useNavigate();

  const handleNavigation = () => {
    navigate('/CandidateDetailsList');
  };

  // Generate options for the chart
  // const chartConfig = {
  //   chart: {
  //     type: 'bar',
  //     height: '30vh',
  //     toolbar: {
  //       show: true, // Show chart toolbar (optional)
  //     },
  //   },
  //   plotOptions: {
  //     bar: {
  //       horizontal: true, // Horizontal bars
  //     },
  //   },
  //   xaxis: {
  //     categories: chartOptions?.labels?.slice(0, visibleDepartments) || ["No Data"],
  //     labels: {
  //       rotate: -45, // Optional: Rotate labels for better visibility
  //     },
  //     title: {
  //       text: 'Departments', // Title of X-axis
  //     },
  //     range: visibleDepartments, // Set the range of visible departments
  //   },
  //   yaxis: {
  //     title: {
  //       text: 'Employee Count', // Y-axis title
  //     },
  //   },
  //   dataLabels: {
  //     enabled: false, // Disable data labels on the bars
  //   },
  //   grid: {
  //     show: true, // Display grid lines for better readability
  //   },
  //   legend: {
  //     position: 'bottom',
  //   },
  // };

  // Series data for the chart (Employee Count for each department)
  // const seriesData = [
  //   {
  //     name: 'Employee Count',
  //     data: chartOptions?.series?.slice(0, visibleDepartments) || [0],
  //   },
  // ];

  // {
  //   chart: {
  //     type: "area",
  //   },
  //   series: [
  //     {
  //       name: "Average Leave Of Employees",
  //       data: [50, 35, 40, 60, 49, 60, 70, 30],
  //     },
  //   ],
  //   xaxis: {
  //     categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"],
  //   },
  //   colors: ["#687cfe"],
  // }

  const getList = () => {
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}DashboardRouter/GetEmployeesCountStatusWise`, {
        params: {
          date: currentDateAndTime(),
          // employee_status: "Active",
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log("GetEmployeesCountStatusWise =>", data);
        if (response.data.success === true) {
          setDailyData((prevState) => ({
            ...prevState,
            employee_count: data?.data?.active_count,
            inactive_count: data?.data?.inactive_count,
          }));
        } else {
        }
      });
  };
  // const getDepartmentWiseCountList = () => {
  //   const headers = apiHeaderJSON;

  //   axios
  //     .get(`${apiURL}DashboardRouter/GetEmployeesCountDepartmentWise`, {
  //       params: {
  //         date: currentDateAndTime(),
  //         employee_status: "Active",
  //       },
  //       headers,
  //     })
  //     .then((response) => {
  //       const data = response.data;
  //       console.log("GetEmployeesCountDepartmentWise =>", data);
  //       if (response.data.success === true) {
          
  //         let departmentTitles = data?.data?.map(
  //           (dept) => dept.department_title
  //         );
  //         console.log("departmentTitles", departmentTitles);
  //         let employeeCounts = data?.data?.map((dept) => dept.employee_count);
  //         console.log("employeeCounts?.length",employeeCounts?.length);
  //         setDepartmentData(employeeCounts?.length);
  //           const seriseData={
  //               name: 'Department Wise Count',
  //               data: [...employeeCounts],
  //             };
  //           const chunkSize = 5; 
  //           const nestedLabels = [];
  //           for (let i = 0; i < departmentTitles.length; i += chunkSize) {
  //             nestedLabels.push(departmentTitles && departmentTitles?.slice(i, i + chunkSize));
  //           }
  //           const chunks = [];
  //           for (let i = 0; i < seriseData.data.length; i += chunkSize) {
  //             chunks.push(seriseData.data && seriseData.data?.slice(i, i + chunkSize));
  //           }
  //           console.log("nestedLabels",nestedLabels)
  //           departmentTitles=nestedLabels;
  //           // Map the chunks into the desired array format
  //           const transformedSeriseData = chunks.map(chunk => ({
  //             name: seriseData.name,
  //             data: chunk,
  //           }));
  //           employeeCounts=transformedSeriseData;
  //           console.log("employeeCounts",employeeCounts)

  //         // setChartOptions({
  //         //   chart: {
  //         //     type: "donut",
  //         //   },
  //         //   series: [
  //         //     {
  //         //       name: "Department Wise Count",
  //         //       data: [...employeeCounts],
  //         //     },
  //         //   ],
  //         //   xaxis: {
  //         //     categories: [...departmentTitles],
  //         //   },
  //         //   colors: ["#687cfe"],
  //         // });

  //         setChartOptions({
  //           labels: departmentTitles || [],
  //           series: employeeCounts || [],
  //         });
  //       } else {
  //         console.error(
  //           "Failed to fetch GetEmployeesCountDepartmentWise count data:",
  //           data.message || "Unknown error"
  //         );
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching data:", error);
  //     });
  // };


  const getDepartmentWiseCountList = () => {
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}DashboardRouter/GetEmployeesCountDepartmentWise`, {
        params: {
          date: currentDateAndTime(),
          employee_status: "Active",
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log("GetEmployeesCountDepartmentWise =>", data);
        if (response.data.success === true) {
          
          let departmentTitles = data?.data?.map(
            (dept) => dept.department_title
          );
          console.log("departmentTitles", departmentTitles);
          let employeeCounts = data?.data?.map((dept) => dept.employee_count);
          console.log("employeeCounts?.length",employeeCounts?.length);
          setDepartmentData(employeeCounts?.length);
            const seriseData={
                name: 'Department Wise Count',
                data: [...employeeCounts],
              };

            const chunkSize = 5; // Number of elements in each chunk
            const nestedLabels = [];
            if(departmentTitles.length>0){
              for (let i = 0; i < departmentTitles.length; i += chunkSize) {
                nestedLabels.push(departmentTitles.slice(i, i + chunkSize));
              }
            }
            else{
              nestedLabels.push("No data");
            }
            departmentTitles=nestedLabels;

            const chunks = [];
            if(seriseData.data.length>0){
              for (let i = 0; i < seriseData.data.length; i += chunkSize) {
                chunks.push(seriseData.data.slice(i, i + chunkSize));
              }
            }
          else{
            chunks.push(0);
          }
            // Map the chunks into the desired array format
            const transformedSeriseData = chunks.map(chunk => ({
              name: seriseData.name,
              data: chunk,
            }));
            employeeCounts=transformedSeriseData;
            console.log("employeeCounts",employeeCounts)

          // setChartOptions({
          //   chart: {
          //     type: "donut",
          //   },
          //   series: [
          //     {
          //       name: "Department Wise Count",
          //       data: [...employeeCounts],
          //     },
          //   ],
          //   xaxis: {
          //     categories: [...departmentTitles],
          //   },
          //   colors: ["#687cfe"],
          // });

          setChartOptions({
            labels: departmentTitles || [], // Labels for the donut slices
            series: employeeCounts || [],
          });
        } else {
        }
      });
  };
  const getLocationWiseCountList = () => {
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}DashboardRouter/GetEmployeesCountLocationWise`, {
        params: {
          date: currentDateAndTime(),
          employee_status: "Active",
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log("GetEmployeesCountLocationWise =>", data);
        if (response.data.success === true) {
          setLocationCount(data?.data);
          const locationTitles = data?.data?.map((dept) => dept.location_title);
          console.log("locationTitles", locationTitles);
          const employeeCounts = data?.data?.map((loc) => loc.employee_count);
          setChartLocationOptions({
            labels: locationTitles || [],
            series: employeeCounts || [],
          });
        } else {
          console.error(
            "Failed to fetch GetEmployeesCountLocationWise count data:",
            data.message || "Unknown error"
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const getGenderWiseCountList = () => {
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}DashboardRouter/GetEmployeesCountGenderWise`, {
        params: {
          employee_status: "active",
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log("GetEmployeesCountGenderWise =>", data);

        if (data.success === true) {
          const genderDataList = data?.data?.map(
            (item) => item.employee_gender
          );
          const genderCounts = data?.data?.map((item) => item.employee_count);

          console.log("genderDataList", genderDataList);
          console.log("genderCounts", genderCounts);

          setGenderData(data?.data);
          setChartOptionsGender({
            labels: genderDataList || [],
            series: genderCounts || [],
          });
        } else {
          console.error(
            "Failed to fetch gender-wise count data:",
            data.message || "Unknown error"
          );
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

 

  
  const getJoinCountMonthWise = async (event) => {
    const selectMonthJoin = event;
    setSelectMonthJoin(selectMonthJoin);
  
    if (!selectMonthJoin) {
      console.warn("No month selected for fetching joining count.");
      return;
    }
  
    console.log("Fetching joining count for month-year:", selectMonthJoin);
  
    const headers = apiHeaderJSON;
  
    try {
      const response = await axios.get(`${apiURL}DashboardRouter/GetEmployeesJoinCountMonthWise`, {
        params: { request_month_year: selectMonthJoin },
        headers,
      });
  
      const data = response.data;
  
      if (data.success) {
        console.log("Joining Count Response:", data);
  
        const joiningCount = Array.isArray(data.data) ? data.data : []; // Ensure it's an array
  
        const processedJoiningCount = joiningCount.map((join) => join.joinie_count || 0);
  
        setJoiningData(processedJoiningCount);
  
        console.log("Processed Joining Count:", processedJoiningCount);
      } else {
        console.error("Failed to fetch joining count. Message:", data.message);
      }
    } catch (error) {
      console.error("Error fetching joining count:", error);
    }
  };
  

  // const getJoinCountMonthWise = (event) => {
  //   const selectMonthJoin = event;
  //   setSelectMonthJoin(selectMonthJoin);
  //   const headers = apiHeaderJSON;
  //   if (selectMonthJoin) {
  //     console.log("Fetching joining count  for month-year:", selectMonthJoin);
  //     axios
  //       .get(`${apiURL}DashboardRouter/GetEmployeesJoinCountMonthWise`, {
  //         params: {
  //           request_month_year: selectMonthJoin,
  //         },
  //         headers,
  //       })
  //       .then((response) => {
  //         const data = response.data;
  //         console.log("JoiningCount:", data);
  //         const joiningCount = data.data;
  //         if (data.success === true) {
  //           setJoiningData(joiningCount);
  //           const joiningData = joiningCount?.map((join) => join.joinie_count || 0);
  //           console.log("Processed Joining Count:", joiningData);
  //         } else {
  //           console.error(
  //             "Failed to fetch joining count. Message:",
  //             data.message
  //           );
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching joining count:", error);
  //       });
  //   }
  // };

  const getAttendanceCountByDepartment = (monthYear) => {
    const selectMonthAttendanceCount = monthYear;
    const headers = apiHeaderJSON;
    if (selectMonthAttendanceCount) {
      console.log(
        "fetching attendence count of department for month-year: ",
        selectMonthAttendanceCount
      );
      axios
        .get(`${apiURL}DashboardRouter/GetAttendanceByDepartment`, {
          params: {
            request_month_year: selectMonthAttendanceCount,
          },
          headers,
        })
        .then((response) => {
          const data = response.data;
          console.log("AttendanceCountByDepartment:", data);
          const attendenceCount = data.data;
          if (data.success === true) {
            setAttendanceData(attendenceCount);

            const departmentTitle = attendenceCount.map(
              (depta) => depta.department_title
            );
            console.log("departmentTitle: ", departmentTitle);
            const attendanceData = attendenceCount?.map(
              (depta) => depta.total_present_days
            );
            console.log("attendanceData: ", attendanceData);

            setCharAttendenceData({
              labels: departmentTitle || [],
              series: attendanceData || [],
            });
          } else {
            console.error(
              "Failed to fetch offer letter count. Message:",
              data.message
            );
          }
        })
        .catch((error) => {
          console.error("Error fetching offer letter count:", error);
        });
    }
  };

  const getMonthlyAttendanceRates = (event) => {
    const selectMonthAttendanceRate = event;
    const headers = apiHeaderJSON;
    if (selectMonthAttendanceRate) {
      console.log(
        "Fetching monthly Attendence rate for month-year:",
        selectMonthAttendanceRate
      );
    }
    axios
      .get(`${apiURL}DashboardRouter/GetPresntAbsentRate`, {
        params: {
          request_month_year: selectMonthAttendanceRate,
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log(
          "MonthlyAttendanceRates =>",
          data,
          parseFloat(data.data?.presentism_percentage) / 100,
          parseFloat(data.data?.absenteeism_percentage) / 100
        );

        if (data.success) {
          console.log("present_rate", setMonthlyAttendanceData);
          setMonthlyAttendanceData({
            present_rate: isNaN(data.data?.presentism_percentage)
              ? 0
              : parseFloat(data.data?.presentism_percentage),
            absence_rate: isNaN(data.data?.absenteeism_percentage)
              ? 0
              : parseFloat(data.data?.absenteeism_percentage),
          });
          console.log("present_rate", setMonthlyAttendanceData);
        } else {
          console.error("Failed to fetch attendance rates:", data.message);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
      });
  };

  const offerStatusOptions = [
    { value: "0", label: "Offer Sent" },
    { value: "1", label: "Offer Viewed" },
    { value: "2", label: "Offer Accepted" },
    { value: "3", label: "Offer Rejected" },
    { value: "4", label: "Offer Cancelled" },
    { value: "5", label: "Offer Expired" },
  ];

  // const getofferLetter = (event, status) => {
  //   const selectMonthOffer = event;
  //   const selectedOfferStatus = status;
  //   setselectMonthAppointment(selectMonthAppointment);
  //   const headers = apiHeaderJSON;
  //   if (selectMonthOffer) {
  //     console.log(
  //       "Fetching offer letter count for month-year:",
  //       selectMonthOffer
  //     );

  //     axios
  //       .get(`${apiURL}DashboardRouter/GetOfferLetterSentCount`, {
  //         params: {
  //           request_month_year: selectMonthOffer,
  //           offer_status: selectedOfferStatus,
  //         },
  //         headers,
  //       })
  //       .then((response) => {
  //         console.log("OfferLetterCount:", response);

  //         const data = response.data;

  //         if (data.success) {
  //           console.log("Offer Letter Count:", data.offer_letter_count);
  //           setOfferLetterCount(data.data.offer_letter_count);
  //         } else {
  //           console.error(
  //             "Failed to fetch offer letter count. Message:",
  //             data.message
  //           );
  //         }
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching offer letter count:", error);
  //       });
  //   }
  // };


  const getofferLetter = (event, status) => {
    const selectMonthOffer = event;
    const selectedOfferStatus = status;
  
    setselectMonthAppointment(selectMonthOffer);
  
    const headers = apiHeaderJSON;
  
    if (selectMonthOffer) {
      console.log(
        "Fetching offer letter count for month-year:",
        selectMonthOffer
      );
  
      axios
        .get(`${apiURL}DashboardRouter/GetOfferLetterSentCount`, {
          params: {
            request_month_year: selectMonthOffer,
            offer_status: selectedOfferStatus,
          },
          headers,
        })
        .then((response) => {
          console.log("OfferLetterCount Response:", response);
  
          const data = response.data;
  
          if (data.success) {
            console.log("Offer Letter Count:", data.offer_letter_count);
            setOfferLetterCount(data.offer_letter_count);
          } else {
            console.error(
              "Failed to fetch offer letter count. Message:",
              data.message || "No additional error message provided by server."
            );
          }
        })
        .catch((error) => {
          console.error("Error fetching offer letter count:", error.message || error);
        });
    } else {
      console.warn("No month-year selected. Skipping offer letter fetch.");
    }
  };
  
  const getAppointmentLetter = (event, status) => {
    const selectMonthAppointment = event;
    const selectedOfferStatus = status;
    setselectMonthAppointment(selectMonthAppointment);
    const headers = apiHeaderJSON;
    if (selectMonthAppointment) {
      console.log(
        "Fetching appointment letter count for month-year:",
        selectMonthAppointment
      );
      axios
        .get(`${apiURL}DashboardRouter/GetAppointmentLetterSentCount`, {
          params: {
            request_month_year: selectMonthAppointment,
            offer_status: selectedOfferStatus,
          },
          headers,
        })
        .then((response) => {
          console.log("AppointmentLetterCount:", response);

          const data = response.data;

          if (data.success) {
            console.log(
              "AppointmentLetterCount:",
              data.data.appointment_letter_count
            );
            setappointmentLetterCount(data.data.appointment_letter_count);
          } else {
            console.error(
              "Failed to fetch appointment letter count. Message:",
              data.message
            );
          }
        })
        .catch((error) => {
          console.error("Error fetching appointments letter count:", error);
        });
    }
  };

  
  


  const getMonthYearOptions = () => {
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}DashboardRouter/GetAllMonthYearFromDatabase`, {
        params: {
          current_date: currentDateAndTime(),
        },
        headers,
      })

      .then((response) => {
        const data = response.data;
        console.log("MonthYearOptions =>", data);

        if (data.success) {
          setMonthYearOptions(data.filterData);
          setSelectedMonthYear(Array.isArray(data.filterData) && data.filterData.length>0 && data.filterData[0]?.value);
        } else {
          console.error("Failed to fetch month-year options");
        }
      })
      .catch((error) => {
        console.error("Error fetching month-year options:", error);
      });
  };

 
  const getDepartmentWiseEarnedSalaryData = (event) => {
    const selectedMonth = event;
    setSelectMonthJoin(selectedMonth);
  
    const headers = apiHeaderJSON;
    setLoading(true);
  
    axios
      .get(`${apiURL}DashboardRouter/GetDepartmentWiseEarnedSalary`, {
        params: { request_month_year: selectedMonth },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log("GetDepartmentWiseEarnedSalary =>", data);
  
        if (response.data.success === true) {
          let departmentTitles = data?.data?.map((dept) => dept.department_name) || [];
          console.log("departmentTitles", departmentTitles);
  
          let earnedSalaries = data?.data?.map((dept) => dept.total_Earned_salary) || [];
          console.log("earnedSalaries", earnedSalaries);
  
          setDepartmentEarnedData(departmentTitles.length);
  
          const chunkSize = 5; // Number of elements in each chunk
          const nestedLabels = [];
  
          if (departmentTitles.length > 0) {
            for (let i = 0; i < departmentTitles.length; i += chunkSize) {
              nestedLabels.push(departmentTitles.slice(i, i + chunkSize));
            }
          } else {
            nestedLabels.push("No data");
          }
  
          departmentTitles = nestedLabels;
  
          const chunks = [];
  
          if (earnedSalaries.length > 0) {
            for (let i = 0; i < earnedSalaries.length; i += chunkSize) {
              chunks.push(earnedSalaries.slice(i, i + chunkSize));
            }
          } else {
            chunks.push(0);
          }
  
          const transformedSeriseData = chunks.map((chunk) => ({
            name: "Department Wise Earned Salary",
            data: chunk,
          }));
  
          earnedSalaries = transformedSeriseData;
          console.log("earnedSalaries", earnedSalaries);
  
          setChartEarnedOptions({
            labels: departmentTitles || [],
            series: earnedSalaries || [],
          });
        } else {
          console.error("Failed to fetch department-wise salary data:", data.message || "Unknown error");
        }
      })
      .catch((error) => {
        console.error("Error fetching department-wise salary data:", error);
      })
      .finally(() => {
        setLoading(false); // Ensure loading state is updated
      });
  };
  
  // const getDepartmentWiseEarnedSalaryData = (event) => {
  //   const selectMonthJoin = event;
  //   setSelectMonthJoin(selectMonthJoin);
  //   const headers = apiHeaderJSON;
  
  //   axios
  //     .get(`${apiURL}DashboardRouter/GetDepartmentWiseEarnedSalary`, {
  //       params: {
  //         request_month_year: selectMonthJoin,
  //       },
  //       headers,
  //     })
  //     .then((response) => {
  //       const data = response.data;
  //       console.log("GetDepartmentWiseEarnedSalary =>", data);
  
  //       if (response.data.success === true) {
  //         const departmentTitles = data?.data?.map(dept => dept.department_name) || [];
  //         const earnedSalaries = data?.data?.map(dept => dept.total_Earned_salary) || [];
  //         const totalDepartments = departmentTitles.length;
  
  //         console.log("departmentTitles", departmentTitles);
  //         console.log("earnedSalaries?.length", earnedSalaries.length);
  
  //         setDepartmentEarnedData(totalDepartments);
  
  //         const chunkSize = 5; // Number of elements in each chunk
  
  //         // Create chunks of labels and series
  //         const chunkedTitles = [];
  //         for (let i = 0; i < departmentTitles.length; i += chunkSize) {
  //           chunkedTitles.push(departmentTitles.slice(i, i + chunkSize));
  //         }
  
  //         const chunkedSeries = [];
  //         for (let i = 0; i < earnedSalaries.length; i += chunkSize) {
  //           chunkedSeries.push(earnedSalaries.slice(i, i + chunkSize));
  //         }
  
  //         // Set chart options
  //         setChartEarnedOptions({
  //           labels: chunkedTitles || [],
  //           series: chunkedSeries.map(chunk => ({
  //             name: "Department Wise Earned Salary",
  //             data: chunk,
  //           })) || [],
  //         });
  //       } else {
  //         console.error("Failed to fetch department-wise salary data");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching department-wise salary data:", error);
  //     });
  // };
  
  
  // const getDepartmentWiseEarnedSalaryData = (event) => {
  //   const selectedMonth = event;
  //   setSelectMonthJoin(selectedMonth);
    
  //   const headers = apiHeaderJSON;
  //   setLoading(true);
  //   axios
  //     .get(`${apiURL}DashboardRouter/GetDepartmentWiseEarnedSalary`, {
  //       params: { request_month_year: selectedMonth },
  //       headers,
  //     })
  //     .then((response) => {
  //       const { data } = response;
  //       console.log("GetDepartmentWiseEarnedSalary =>", data);
  
  //       // Ensure data exists and is in the expected structure
  //       if (data.success) {
  //         setLoading(false)
  //         const departmentTitles = data?.data?.map((dept) => dept.department_name) || [];
  //         const earnedSalaries = data?.data?.map((dept) => dept.total_Earned_salary) || [];
          
  //         console.log("departmentTitles:", departmentTitles);
  //         console.log("earnedSalaries:", earnedSalaries);
  
  //         const totalDepartments = departmentTitles.length;
  //         if (earnedSalaries.length === 0) {
  //           console.warn("No data available for the selected month.");
  //         }
  
  //         setDepartmentEarnedData(totalDepartments);
  
  //         // Chunk the data into smaller arrays for better chart handling
  //         const chunkSize = 5;
  
  //         const chunkedTitles = chunkData(departmentTitles, chunkSize);
  //         const chunkedSalaries = chunkData(earnedSalaries, chunkSize);
  
  //         // Set the chart options
  //         setChartEarnedOptions({
  //           labels: chunkedTitles || [],
  //           series: chunkedSalaries.map((chunk) => ({
  //             name: "Department Wise Earned Salary",
  //             data: chunk,
  //           })) || [],
  //         });
  //       } else {
  //         console.error("Failed to fetch department-wise salary data:", data.message || "Unknown error");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching department-wise salary data:", error);
  //     });
  // };
  
  // Utility function to chunk an array
  // const chunkData = (data, chunkSize) => {
  //   const chunked = [];
  //   for (let i = 0; i < data.length; i += chunkSize) {
  //     chunked.push(data && data?.slice(i, i + chunkSize));
  //   }
  //   return chunked;
  // }; 

  // Utility function to chunk an array
const chunkData = (data, chunkSize) => {
  if (!Array.isArray(data)) {
    console.warn("Invalid input: data is not an array");
    return []; 
  }

  const chunked = [];
  for (let i = 0; i < data.length; i += chunkSize) {
    chunked.push(data.slice(i, i + chunkSize));
  }
  return chunked;
};

  
  const getLocationWiseEarnedSalaryData = (event) => {
    const selectMonthJoin = event;
    setSelectMonthJoin(selectMonthJoin);
    const headers = apiHeaderJSON;
  
    axios
      .get(`${apiURL}DashboardRouter/GetLocationWiseEarnedSalary`, {
        params: {
          request_month_year: selectMonthJoin,
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log("GetLocationWiseEarnedSalary =>", data);
  
        if (response.data.success === true) {
          const locationData = data?.data || []; // Ensure it's an array
          if (locationData.length === 0) {
            console.warn("No data available for the selected month.");
          }
  
          setLocationEarnedData(locationData);
  
          const locationTitles = locationData.map((dept) => dept.location_name);
          const earnedSalaries = locationData.map((dept) => dept.total_Earned_salary);
  
          setChartEarnedLocOptions({
            labels: locationTitles || [], // Labels for the donut slices
            series: earnedSalaries || [],
          });
        } else {
          console.error("Failed to fetch location-wise salary data. Message:", data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching location-wise salary data:", error);
      });
  };
  const getDesignationWiseEarnedSalaryData = (event) => {
    const selectMonthLocOver = event;
    setSelectMonthDesignationOver(selectMonthLocOver);
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}DashboardRouter/GetEmployeesCountDesignationWise`, {
        params: {
          date: currentDateAndTime(),
          employee_status: "Active",
        },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log("GetEmployeesCountDesignationWise =>", data);
        if (response.data.success === true) {
          const chunkSize = 5; // Number of elements in each chunk
          const chunkedTitles = [];
          const chunkedSeries = [];
          const designationTitles = data?.data?.map(
            (dept) => dept.designation_title
          );
          setDesignationData(designationTitles.length);
          if (designationTitles.length > 0) {
            for (let i = 0; i < designationTitles.length; i += chunkSize) {
              chunkedTitles.push(designationTitles.slice(i, i + chunkSize));
            }
          }
          const designationWiseCount = data?.data?.map((dept) => dept.employee_count);

          if (designationWiseCount.length > 0) { 
            for (let i = 0; i < designationWiseCount.length; i += chunkSize) {
              chunkedSeries.push(designationWiseCount.slice(i, i + chunkSize));
            }
          } else {
            chunkedSeries.push([0]); // Ensure this is an array for consistency
          }
          let transformedSeriesData = chunkedSeries.map((chunk) => ({
            name: "Designation Wise Employee Count",
            data: chunk,
          }));
          transformedSeriesData=transformedSeriesData?.length>0? transformedSeriesData:[{ name: 'No Data', data: [0] }];
          console.log("chunkedTitles designation", chunkedTitles);
          console.log("transformedSeriesData designation", transformedSeriesData);
          setDesignationOptions({
            labels: chunkedTitles, 
            series: transformedSeriesData,
          } );
        } else {
          console.error("Failed to fetch designation-wise salary data. Message:", data.message);
        }
      })
      .catch((error) => {
        console.error("Error fetching designation-wise salary data:", error);
      });
  };
  


  const getDepartmentWiseNetSalaryData = (event) => {
    const selectMonthNet = event;
    setSelectMonthJoin(selectMonthNet);
  
    const headers = apiHeaderJSON;
    setLoading1(true);
  
    axios
      .get(`${apiURL}DashboardRouter/GetDepartmentWiseNetSalary`, {
        params: { request_month_year: selectMonthNet },
        headers,
      })
      .then((response) => {
        const data = response.data;
        console.log("GetDepartmentWiseNetSalary =>", data);
  
        if (response.data.success === true) {
          let departmentTitles = data?.data?.map((dept) => dept.department_name) || [];
          console.log("departmentTitles", departmentTitles);
  
          let netSalaries = data?.data?.map((dept) => dept.total_Net_salary) || [];
          console.log("netSalaries", netSalaries);
  
          setDepartmentNetData(departmentTitles.length);
  
          const chunkSize = 5; // Number of elements in each chunk
          const nestedLabels = [];
  
          if (departmentTitles.length > 0) {
            for (let i = 0; i < departmentTitles.length; i += chunkSize) {
              nestedLabels.push(departmentTitles.slice(i, i + chunkSize));
            }
          } else {
            nestedLabels.push("No data");
          }
  
          departmentTitles = nestedLabels;
  
          const chunks = [];
  
          if (netSalaries.length > 0) {
            for (let i = 0; i < netSalaries.length; i += chunkSize) {
              chunks.push(netSalaries.slice(i, i + chunkSize));
            }
          } else {
            chunks.push(0);
          }
  
          const transformedSeriseData = chunks.map((chunk) => ({
            name: "Department Wise Net Salary",
            data: chunk,
          }));
  
          netSalaries = transformedSeriseData;
          console.log("netSalaries", netSalaries);
  
          setChartNetOptions({
            labels: departmentTitles || [],
            series: netSalaries || [],
          });
        } else {
          console.error("Failed to fetch department-wise net salary data:", data.message || "Unknown error");
        }
      })
      .catch((error) => {
        console.error("Error fetching department-wise net salary data:", error);
      })
      .finally(() => {
        setLoading1(false); // Ensure loading state is updated
      });
  };
  
    const getLocationWiseNetSalaryData = (event) => {
      const selectedMonthLocNet = event;
      setSelectMonthJoin(selectedMonthLocNet);
      const headers = apiHeaderJSON;
    
      axios
        .get(`${apiURL}DashboardRouter/GetLocationWiseNetSalary`, {
          params: {
            request_month_year: selectedMonthLocNet,
          },
          headers,
        })
        .then((response) => {
          const locData = response.data;  // Access data from response.data
          console.log("GetLocationWiseNetSalary:", locData);
    
          if (response.data.success === true) {
            setLocationNetData(locData?.data);
    
            const locationTitles = locData?.data?.map((dept) => dept.location_name);
            console.log("locationTitles", locationTitles);
    
            const netSalaries = locData?.data?.map((dept) => dept.total_Net_salary);
            console.log("netSalaries", netSalaries);
    
            setChartNetLocOptions({
              labels: locationTitles || [],
              series: netSalaries || [],
            });
          } else {
            console.error("No location data available.");
          }
        })
        .catch((error) => {
          console.error("Error fetching location-wise salary data:", error);
        });
    };
   
    const getDepartmentWiseOverTimeHours = (event) => {
      const selectMonthOver = event;
      setSelectMonthOver(selectMonthOver);
    
      const headers = apiHeaderJSON;
      setLoading2(true);
    
      axios
        .get(`${apiURL}DashboardRouter/GetDepartmentWiseOverTimeHours`, {
          params: { request_month_year: selectMonthOver },
          headers,
        })
        .then((response) => {
          const data = response.data;
          console.log("GetDepartmentWiseOverTimeHours =>", data);
    
          if (data.success === true && Array.isArray(data.data)) {
            const departmentTitles = data.data.map((dept) => dept.department_name || "Unknown");
            const overTimeHours = data.data.map((dept) => dept.total_overtime_hours || 0);
    
            console.log("departmentTitles", departmentTitles);
            console.log("overTimeHours", overTimeHours);
    
            setDepartmentOverTimeData(departmentTitles.length);
    
            const chunkSize = 5; // Number of elements in each chunk
            const chunkedTitles = [];
            const chunkedSeries = [];
    
            if (departmentTitles.length > 0) {
              for (let i = 0; i < departmentTitles.length; i += chunkSize) {
                chunkedTitles.push(departmentTitles.slice(i, i + chunkSize));
              }
            } else {
              chunkedTitles.push("No data");
            }
    
            if (overTimeHours.length > 0) { 
              for (let i = 0; i < overTimeHours.length; i += chunkSize) {
                chunkedSeries.push(overTimeHours.slice(i, i + chunkSize));
              }
            } else {
              chunkedSeries.push([0]); // Ensure this is an array for consistency
            }
    
            console.log("chunkedTitles", chunkedTitles);
            console.log("chunkedSeries", chunkedSeries);
    
            const transformedSeriesData = chunkedSeries.map((chunk) => ({
              name: "Department Wise Over Time Hours",
              data: chunk,
            }));
    
            setChartOverTimeOptions({
              labels: chunkedTitles || [],
              series: transformedSeriesData || [],
            });
          } else {
            console.error(
              "Failed to fetch department-wise OverTimeHours data or data is not in expected format:",
              data.message || "Unknown error"
            );
            setChartOverTimeOptions({
              labels: ["No data"],
              series: [],
            });
          }
        })
        .catch((error) => {
          console.error("Error fetching department-wise OverTimeHours data:", error);
        })
        .finally(() => {
          setLoading2(false); // Ensure loading state is updated
        });
    };
    
    
    

    const getLocationWiseOverTimeHours = (event) => {
      const selectMonthLocOver = event;
      setSelectMonthLocOver(selectMonthLocOver);
      const headers = apiHeaderJSON;
  
      axios
        .get(`${apiURL}DashboardRouter/GetLocationWiseOverTimeHours`, {
          params: {
            request_month_year:selectMonthLocOver ,
          },
          headers,
        })
        .then((response) => {
          const locOver = response.data;
          console.log("GetDepartmentWiseOverTimeHours =>", locOver);
          if (response.data.success === true) {
            setDepartmentOverTimeData(locOver?.data);
  
            const LocationTitles = locOver?.data?.map(
              (dept) => dept.location_name
            );
            console.log("departmentTitles", LocationTitles);
  
            const overTimeHours = locOver?.data?.map((dept) => dept.total_overtime_hours);
            
            setChartLocOverTimeOptions({
              labels: LocationTitles || [], // Labels for the donut slices
              series: overTimeHours || [],
            });
          } else {
            console.error("Failed to fetch department-wise OverTimeHours data");
          }
        })
        .catch((error) => {
          console.error("Error fetching department-wise OverTimeHours data:", error);
        });
    };

  const handleSelectChange = (name, selectedOption) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));

    const selectedValue = selectedOption ? selectedOption.value : "";

    if (name === "month_year") {
      if (selectedValue !== selectedMonthYear) {
        setSelectedMonthYear(selectedValue);
        console.log("Month-Year changed to:", selectedValue);
        getAppointmentLetter(selectedValue, selectedOfferStatus);
        getofferLetter(selectedValue, selectedOfferStatus);
        getAttendanceCountByDepartment(selectedValue);
        getMonthlyAttendanceRates(selectedValue);
        getAttendanceCountByDepartment(selectedValue);
        getJoinCountMonthWise(selectedValue);
        getDepartmentWiseEarnedSalaryData(selectedValue);
        getLocationWiseEarnedSalaryData(selectedValue);
        getDepartmentWiseNetSalaryData(selectedValue)
        getLocationWiseNetSalaryData(selectedValue);
        getDepartmentWiseOverTimeHours(selectedValue);
        // getDepartmentWiseGrossSalaryMonthWise(selectedValue);
        // getLocationWiseGrossSalaryMonthWise(selectedValue);
        getLocationWiseOverTimeHours(selectedValue)
        setSelectedMonthYear(selectedOption?.value || null);
      }
    } else if (name === "offer_status") {
      if (selectedValue !== selectedOfferStatus) {
        setSelectedOfferStatus(selectedValue);
        console.log("Offer Status changed to:", selectedValue);
        getofferLetter(selectedMonthYear, selectedValue);
        getAppointmentLetter(selectedMonthYear, selectedValue);
      }
    }
  };

  useEffect(() => {
    getList();
  
    getDepartmentWiseCountList();
    getLocationWiseCountList();
    getGenderWiseCountList();
    getMonthYearOptions();
    getDesignationWiseEarnedSalaryData();
    // getCurrentMonthYear();
    if (inputRef.current) {
      flatpickr(inputRef.current, {
        dateFormat: "d M, Y",
        defaultDate: "today",
        inline: true,
      });
    }
    const sourceDiv = sourceDivRef.current;

    if (sourceDiv) {
      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          // Update the target div height whenever the source div resizes
          setTargetDivHeight(`${entry.contentRect.height}px`);
        }
      });

      // Observe the source div for resizing
      resizeObserver.observe(sourceDiv);

      return () => {
        // Clean up observer on component unmount
        resizeObserver.disconnect();
      };
    }
  }, []);
  const [showMore, setShowMore] = useState(false);
  const handleShowMore = () => {
    setShowMore(!showMore);
       setVisibleDepartments(showMore ? 6 : chartOptions?.labels?.length);
  };
  const renderLabels = (labels) => labels?.length > 0 ? labels : ['No Data'];
  const renderSeries = (series) => series?.length > 0 ? series : [0];

   const chartOptionsLine = {
    chart: {
      type: "line",
    },
    series: [
      {
        name: "Joins",
        data: [30, 40, 45, 50, 49, 60, 70, 91],
      },
    ],
    xaxis: {
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"],
    },
    colors: ["#687cfe"],
  };

  const [currentIndex, setCurrentIndex] = useState({
    departmentWiseCountIndex:0,
    designationWiseCountIndex:0,
    departmentWiseEarnedGrossIndex:0,
    departmentWiseNetGrossIndex:0,
    departmentWiseOverTimeHoursIndex:0,
  });
  const [animationDirection, setAnimationDirection] = useState({
    departmentWiseCountAnimation:"",
    designationWiseCountAnimation:"",
    departmentWiseEarnedGrossAnimation:"",
    departmentWiseNetGrossAnimation:"",
    departmentWiseOverTimeHoursAnimation:"",

  });
  const [currentIndex1,setCurrentIndex1]= useState(0);
  const [currentIndex2,setCurrentIndex2]= useState(0);
  const [currentIndex3,setCurrentIndex3]= useState(0);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
   // For controlling the slide direction
  const [animating, setAnimating] = useState(false);

const handlePrev = (type) => {
if (animating) return;
  if (type === "1") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseCountAnimation:"slide-right",
    });
  } else if (type === "2") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseEarnedGrossAnimation:"slide-right",
    });
  } else if (type === "3") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseNetGrossAnimation:"slide-right",
    });
  } 
  else if (type === "4") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseOverTimeHoursAnimation:"slide-right",
    });
  }
  else if (type === "5") {
    setAnimationDirection({
      ...animationDirection,
      designationWiseCountAnimation:"slide-right",
    });
  }
 setAnimating(true);
 
  setTimeout(() => {
    if(type==="1"){
      setCurrentIndex({
        ...currentIndex,
        departmentWiseCountIndex:(currentIndex?.departmentWiseCountIndex === 0 ? chartOptions.series.length - 1 : currentIndex?.departmentWiseCountIndex - 1),
      });
    }else if(type==="2"){
      setCurrentIndex({
        ...currentIndex,
        departmentWiseEarnedGrossIndex:(currentIndex?.departmentWiseEarnedGrossIndex === 0 ? chartEarnedOptions.series.length - 1 : currentIndex?.departmentWiseEarnedGrossIndex - 1),
      });
    }else if(type==="3"){
      setCurrentIndex({
        ...currentIndex,
        departmentWiseNetGrossIndex:(currentIndex?.departmentWiseNetGrossIndex === 0 ? chartNetOptions.series.length - 1 : currentIndex?.departmentWiseNetGrossIndex - 1),
      });
    }
    else if(type==="4"){
      setCurrentIndex({
        ...currentIndex,
        departmentWiseOverTimeHoursIndex:(currentIndex?.departmentWiseOverTimeHoursIndex === 0 ? chartOptions.series.length - 1 : currentIndex?.departmentWiseOverTimeHoursIndex - 1),
      });
      }
    else if(type==="5"){
      setCurrentIndex({
        ...currentIndex,
        designationWiseCountIndex:(currentIndex?.designationWiseCountIndex === 0 ? designationOptions.series.length - 1 : currentIndex?.designationWiseCountIndex - 1),
      });
      }
   
    setAnimationDirection({
      departmentWiseCountAnimation:"",
      designationWiseCountAnimation:"",
      departmentWiseEarnedGrossAnimation:"",
      departmentWiseNetGrossAnimation:"",
      departmentWiseOverTimeHoursAnimation:"",
    });
    setAnimating(false);
  }, 500); 
}
const handleNext = (type) => {
  if (animating) return;

  if (type === "1") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseCountAnimation:"slide-left",
    });
  } else if (type === "2") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseEarnedGrossAnimation:"slide-left",
    });
  } else if (type === "3") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseNetGrossAnimation:"slide-left",
    });
  } else if (type === "4") {
    setAnimationDirection({
      ...animationDirection,
      departmentWiseOverTimeHoursAnimation:"slide-left",
    });
  }
  else if (type === "5") {
    setAnimationDirection({
      ...animationDirection,
      designationWiseCountAnimation:"slide-left",
    });
  }
  setAnimating(true);

  setTimeout(() => {
    if(type==="1"){
      setCurrentIndex({
        ...currentIndex,
        departmentWiseCountIndex:(currentIndex?.departmentWiseCountIndex === chartOptions.series.length - 1 ? 0 : currentIndex?.departmentWiseCountIndex + 1),
      });
    }
    else if(type==="2"){
    setCurrentIndex({
        ...currentIndex,
        departmentWiseEarnedGrossIndex:(currentIndex?.departmentWiseEarnedGrossIndex === chartEarnedOptions.series.length - 1 ? 0 : currentIndex?.departmentWiseEarnedGrossIndex + 1),
      });
  
    } else if(type==="3"){
     setCurrentIndex({
        ...currentIndex,
        departmentWiseNetGrossIndex:(currentIndex?.departmentWiseNetGrossIndex === chartNetOptions.series.length - 1 ? 0 : currentIndex?.departmentWiseNetGrossIndex + 1),
      });
      
    }
    else if(type==="4"){
     setCurrentIndex({
        ...currentIndex,
        departmentWiseOverTimeHoursIndex:(currentIndex?.departmentWiseOverTimeHoursIndex === chartOptions.series.length - 1 ? 0 : currentIndex?.departmentWiseOverTimeHoursIndex + 1),
      });
      // setCurrentIndex1((prev) => (prev === chartOverTimeOptions.series.length - 1 ? 0 : prev + 1));
    }
    else if(type==="5"){
     setCurrentIndex({
        ...currentIndex,
        designationWiseCountIndex:(currentIndex?.designationWiseCountIndex === designationOptions.series.length - 1 ? 0 : currentIndex?.designationWiseCountIndex + 1),
      });
      // setCurrentIndex1((prev) => (prev === chartOverTimeOptions.series.length - 1 ? 0 : prev + 1));
    }
    
    // setCurrentIndex1((prev) => (prev === chartEarnedOptions.series.length - 1 ? 0 : prev + 1));
    // setCurrentIndex2((prev) => (prev === chartNetOptions.series.length - 1 ? 0: prev + 1));
    // setCurrentIndex3((prev) => (prev === chartOverTimeOptions.series.length - 1 ? 0: prev + 1));
     setAnimationDirection({
      departmentWiseCountAnimation:"",
      designationWiseCountAnimation:"",
      departmentWiseEarnedGrossAnimation:"",
      departmentWiseNetGrossAnimation:"",
      departmentWiseOverTimeHoursAnimation:"",
     });
    setAnimating(false);

  }, 500); // Match the CSS transition duration
};
  
  // const absenceRate = parseFloat(.absence_rate) / 100; // Convert "16.99%" to 0.1699
  // const presentRate = parseFloat(attendanceData.present_rate)
  return (
    <div className="card p-2">
      <div className="row col-md-12 mt-3">
      <div className="col-xl-4">
          <div className="card card-animate">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="avatar-sm flex-shrink-0">
                  <span className="avatar-title bg-success-subtle rounded-2 fs-2">
                    <i className="bx bx-calendar-check text-primary" />
                  </span>
                </div>
                <div className="flex-grow-1 ms-3 cursor-pointer hover-effect" onClick={handleNavigation}>
                          <p className="text-uppercase fw-medium text-muted mb-3">Active Employees</p>
                          <div className="d-flex align-items-center mb-3">
                            <h4 className="flex-grow-1 mb-0">
                              <span className="counter-value" data-target={0}>
                                {dailyData?.employee_count || 0}
                              </span>
                            </h4>
                  </div>
  <p className="text-muted mb-0">Total Employees</p>
</div>

              </div>
            </div>
            {/* end card body */}
          </div>
      </div>
      <div className="col-xl-4">
          <div className="card card-animate">
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="avatar-sm flex-shrink-0">
                  <span className="avatar-title bg-secondary-subtle rounded-2 fs-2">
                    <i className="bx bx-calendar-x text-secondary" />
                  </span>
                </div>
                <div className="flex-grow-1 ms-3" onClick={handleNavigation}>
                  <p className="text-uppercase fw-medium text-muted mb-3">
                  Inactive Employees
                  </p>
                  <div className="d-flex align-items-center mb-3">
                    <h4 className="flex-grow-1 mb-0">
                      <span className="counter-value" data-target={0}>
                      {dailyData?.inactive_count || 0}
                      </span>
                    </h4>
                    {/* <span className="badge bg-success-subtle text-success fs-12">
                      <i className="ri-arrow-up-s-line fs-13 align-middle me-1" />
                      3.58 %
                    </span> */}
                  </div>
                  <p className="text-muted mb-0">Total Employees</p>
                </div>
              </div>
            </div>
            {/* end card body */}
          </div>
      </div>
      <div className="col-xl-4">
        <div className="card p-2">
          <div className="text-center mt-4">
            <h5>Gender Wise Count</h5>
          </div>
          <ApexCharts
            options={{
              chart: {
                type: "donut",
                height: "30vh",
              },
              labels: chartOptionsfGender?.labels || [],
              legend: {
                position: "bottom",
              },
              plotOptions: {
                pie: {
                  donut: {
                    size: "65%",
                    labels: {
                      show: false,
                      name: {
                        show: true,
                      },
                      value: {
                        show: true,
                      },
                    },
                  },
                },
              },
            }}
            series={chartOptionsfGender?.series || []} // Employee counts for departments
            type="donut"
          />
        </div>
      </div>
    </div>
           
    <div className="row">
      <div className="col-xl-6">
        <div ref={sourceDivRef} className="card p-2">
          <div>
            <div className="text-center mt-3">
              <h5>Department Wise Employee Count</h5>
            </div>
          </div>
          <div className="overflow-hidden">
            {/* <div className=" col-xl-12 overflow-hidden"> */}
              {departmentData>5 && (<button onClick={()=>{handlePrev("1")}} className="nav-btn prev-btn">Prev</button>)}
              <div className={`chart-wrapper ${animationDirection?.departmentWiseCountAnimation}`}>
                <ApexCharts
                  options={{
                    chart: {
                      type: 'bar',
                      height: '50vh',
                      toolbar: { show: true },
                    },
                    plotOptions: {
                      bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded',
                      },
                    },
                    dataLabels: {
                      enabled: true, // Enable data labels
                      style: {
                        fontSize: '12px',
                        colors: ['#020d70'],
                      },
                      offsetY: -10,
                      formatter: function (val) {
                        return `${val}`; // Customize the format of the label (e.g., add units if needed)
                      },
                    },
                    stroke: {
                      show: true,
                      width: 2,
                      colors: ['transparent'],
                    },
                    xaxis: {
                      categories: Array.isArray(chartOptions?.labels) && chartOptions?.labels.length>0
                      ?chartOptions.labels[currentIndex?.departmentWiseCountIndex] : ['No Data'],
                      title: {
                        text: `Departments ${departmentData>5 ? `(${currentIndex?.departmentWiseCountIndex+1}-${chartOptions?.labels.length})`:''}`,
                        style: { fontSize: '12px', fontWeight: 'bold' },
                      },
                    },
                    yaxis: {
                      title: {
                        text: 'Count',
                        style: { fontSize: '12px', fontWeight: 'bold' },
                      },
                    },
                    fill: {
                      opacity: 1,
                    },
                    legend: {
                      position: 'top',
                      horizontalAlign: 'center',
                    },
                    tooltip: {
                      y: {
                        formatter: function (value) {
                          return `${value}`;
                        },
                      },
                    },
                  }}
                  series={[Array.isArray(chartOptions?.series)? chartOptions?.series[currentIndex?.departmentWiseCountIndex]: {name:"No Data", data:[0]}]}
                  type="bar"
                />
              </div>
              {departmentData>5 && (<button onClick={()=> {handleNext("1")}} className="nav-btn next-btn">Next</button>)}
            {/* </div> */}
          </div>
          {/* <h1 className="">{currentIndex+1}</h1> */}
        </div>
      </div>
      <div className="col-xl-6">
        <div ref={sourceDivRef} className="card p-2">
          <div>
            <div className="text-center mt-3">
              <h5>Designation Wise Employee Count</h5>
            </div>
          </div>
          <div className="overflow-hidden">
            {/* <div className=" col-xl-12 overflow-hidden"> */}
              {designationData>5 && (<button onClick={()=>{handlePrev("5")}} className="nav-btn prev-btn">Prev</button>)}
              <div className={`chart-wrapper ${animationDirection?.designationWiseCountAnimation}`}>
                <ApexCharts
                  options={{
                    chart: {
                      type: 'bar',
                      height: '50vh',
                      toolbar: { show: true },
                    },
                    plotOptions: {
                      bar: {
                        horizontal: false,
                        columnWidth: '55%',
                        endingShape: 'rounded',
                      },
                    },
                    colors: ['#929dfb'], 
                    dataLabels: {
                      enabled: true, // Enable data labels
                      style: {
                        fontSize: '12px',
                        colors: ['#020d70'],
                      },
                      offsetY: -10,
                      formatter: function (val) {
                        return `${val}`; // Customize the format of the label (e.g., add units if needed)
                      },
                    },
                    stroke: {
                      show: true,
                      width: 2,
                      colors: ['transparent'],
                    },
                    xaxis: {
                      categories: Array.isArray(designationOptions?.labels) && designationOptions?.labels.length>0
                      ?designationOptions.labels[currentIndex?.designationWiseCountIndex] : ['No Data'],
                      title: {
                        text: `Designations ${designationData>5 ? `(${currentIndex?.designationWiseCountIndex+1}-${designationOptions?.labels.length})`:''}`,
                        style: { fontSize: '12px', fontWeight: 'bold' },
                      },
                    },
                    yaxis: {
                      title: {
                        text: 'Count',
                        style: { fontSize: '12px', fontWeight: 'bold' },
                      },
                    },
                    fill: {
                      opacity: 1,
                    },
                    legend: {
                      position: 'top',
                      horizontalAlign: 'center',
                    },
                    tooltip: {
                      y: {
                        formatter: function (value) {
                          return `${value}`;
                        },
                      },
                    },
                  }}
                  series={[Array.isArray(designationOptions?.series) && designationOptions?.series.length>0
                    ? designationOptions?.series[currentIndex?.designationWiseCountIndex]: {name:"No Data", data:[0]}]}
                  type="bar"
                />
              </div>
              {designationData>5 && (<button onClick={()=> {handleNext("5")}} className="nav-btn next-btn">Next</button>)}
            {/* </div> */}
          </div>
          {/* <h1 className="">{currentIndex+1}</h1> */}
        </div>
      </div>


      {/* Second Chart - Location Wise Employee Count */}
       <div className="col-xl-6">
        <div ref={sourceDivRef} className="card p-2">
          <div>
            <div className="text-center mt-3">
              <h5>Location Wise Employee Count</h5>
            </div>
          </div>
          <ApexCharts
            options={{
              chart: {
                type: 'donut',
                height: '30vh',
              },
              labels: renderLabels(chartLocationOptions?.labels || ["No Data"]),
              legend: {
                position: 'bottom',
              },
              plotOptions: {
                pie: {
                  donut: {
                    // size: chartLocationOptions?.labels?.length > 10 ? '70%' : '65%', // Increase donut size for large datasets
                    size:'70%',
                    
                    labels: {
                      show: false,
                      name: {
                        show: true,
                      },
                      value: {
                        show: true,
                        formatter: function (val, opts) {
                          // Add ₹ symbol before the value
                          const value = opts?.w?.config?.series?.[opts.seriesIndex] ?? val;
                          return `${value}`;
                        },
                      },
                    },
                  },
                },
              },
              dataLabels: {
                enabled: true,
                formatter: function (val, opts) {
                  
                  const value = opts?.w?.config?.series?.[opts.seriesIndex] ?? val;
                  return `${value}`;
                },
              },
            }}
            
            series={renderSeries(chartLocationOptions?.series || [0])}
            type="donut"
          />
          {/* Button to toggle "More" option */}
          {/* {chartLocationOptions?.labels?.length > 10 && (
            <button onClick={handleShowMore} className="btn btn-link">
              {showMore ? 'Show Less' : 'Show More'}
            </button>
          )} */}
        </div>
      </div> 
    </div>
          <div className="row">
 
    <div className="row">



</div>
</div>
</div>

      
    
  );
};
export default EmployeesDashboard;
